document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".our-experts-new");
  const BREAKPOINT = 992;

  sections.forEach((section) => {
    const swiperEl = section.querySelector(".our-experts-new__swiper");
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll(".swiper-slide");
    const prevEl = section.querySelector(".swiper-controls .prev");
    const nextEl = section.querySelector(".swiper-controls .next");
    const hasMultipleSlides = slides.length > 1;
    const portraitImages = section.querySelectorAll(".our-experts-new__portrait");

    let swiperInstance = null;
    let resizeFrame = null;

    function getSourceCardElements() {
      const sourceCards = section.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate) .inner-wrapper",
      );

      return sourceCards.length
        ? Array.from(sourceCards)
        : Array.from(section.querySelectorAll(".inner-wrapper"));
    }

    function getAllCardElements() {
      return Array.from(section.querySelectorAll(".inner-wrapper"));
    }

    function resetHeights() {
      getAllCardElements().forEach((cardEl) => {
        cardEl.style.height = "";
      });
    }

    function equalizeHeights() {
      const sourceCardEls = getSourceCardElements();
      const allCardEls = getAllCardElements();

      if (!sourceCardEls.length || !allCardEls.length) return;

      resetHeights();

      window.requestAnimationFrame(() => {
        const tallestCard = Math.max(
          ...sourceCardEls.map((cardEl) => cardEl.getBoundingClientRect().height),
        );

        allCardEls.forEach((cardEl) => {
          cardEl.style.height = `${Math.ceil(tallestCard)}px`;
        });
      });
    }

    function scheduleEqualizeHeights() {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        equalizeHeights();
        resizeFrame = null;
      });
    }

    function initSwiper() {
      if (swiperInstance || window.innerWidth >= BREAKPOINT) return;

      swiperInstance = new Swiper(swiperEl, {
        loop: hasMultipleSlides,
        slidesPerView: 1,
        spaceBetween: 24,
        autoplay: false,
        allowTouchMove: true,
        speed: 800,
        watchOverflow: true,
        navigation:
          hasMultipleSlides && prevEl && nextEl
            ? { nextEl, prevEl }
            : undefined,
        on: {
          init: scheduleEqualizeHeights,
        },
      });
    }

    function destroySwiper() {
      if (!swiperInstance) return;

      swiperInstance.destroy(true, true);
      swiperInstance = null;
      scheduleEqualizeHeights();
    }

    function handleResize() {
      if (window.innerWidth < BREAKPOINT) {
        initSwiper();
      } else {
        destroySwiper();
      }

      scheduleEqualizeHeights();
    }

    portraitImages.forEach((imageEl) => {
      if (imageEl.complete) return;

      imageEl.addEventListener("load", scheduleEqualizeHeights, {
        once: true,
      });
    });

    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", scheduleEqualizeHeights, { once: true });
  });
});
